import { NowPlayingStyle } from 'components/NowPlaying';
import NowPlayingPage from 'pages/NowPlayingPage';
import RoulettePage from 'pages/Roulette';
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import SetlistControllerPage from 'pages/SetlistController';
import SetlistDisplayPage from 'pages/SetlistDisplay';
import SetlistDisplayOverlayPage from 'pages/SetlistDisplayOverlay';
import SetlistBrowserPage from 'pages/SetlistBrowser';
import OverlayListPage from 'pages/OverlayList';
import Songlist from 'pages/Songlist';

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="overlay">
          <Route
            path="5"
            element={<NowPlayingPage style={NowPlayingStyle.MinimalMark2} />}
          />
          <Route
            path="4"
            element={<NowPlayingPage style={NowPlayingStyle.Sakura} />}
          />
          <Route
            path="3"
            element={<NowPlayingPage style={NowPlayingStyle.Night} />}
          />
          <Route
            path="2"
            element={<NowPlayingPage style={NowPlayingStyle.Minimal} />}
          />
          <Route path="1" element={<NowPlayingPage />} />
          <Route path="setlist">
            <Route path="controller" element={<SetlistControllerPage />} />
            <Route path="display" element={<SetlistDisplayPage />} />
            <Route path="display2" element={<SetlistDisplayOverlayPage />} />
            <Route path="browser" element={<SetlistBrowserPage />} />
          </Route>
          <Route index element={<NowPlayingPage />} />
        </Route>
        <Route path="/roulette" element={<RoulettePage />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Songlist />} />
          <Route path="songlist" element={<Songlist />} />
          <Route path="overlays" element={<OverlayListPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
